import { render, staticRenderFns } from "./JCReport.vue?vue&type=template&id=c58ea950&scoped=true&"
import script from "./JCReport.vue?vue&type=script&lang=js&"
export * from "./JCReport.vue?vue&type=script&lang=js&"
import style0 from "./JCReport.vue?vue&type=style&index=0&id=c58ea950&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58ea950",
  null
  
)

export default component.exports